<template>
  <div class="vehicleList">
    <div class="table_modle">
      <h2>卸车排队</h2>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" label="序号"  width="50" />
        <el-table-column prop="CarSiteID" label="类别" />
        <el-table-column prop="TotalNo" label="队列" />
        <el-table-column prop="CarNo" label="车号" />
        <el-table-column prop="StateName" label="状态" />
      </el-table>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        tableData: [],
        timeFun: '',
      };
    },
    created() {
      this.tableInfo();
      this.timeFun = setInterval(() => {
        this.tableInfo();
      }, 30000);
    },
    // clearInterval(begin)
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timeFun);
      next();
    },
    methods: {
      tableInfo() {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'listCarList',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.tableData = res.bean.outCarList;
          // this.tableRight = res.bean.outCarList;
        });
      },
    },
  };
</script>
<style lang="scss">
  .vehicleList{
    width: 100%;
    h2{
      margin: 0;
      text-align: center;
    }
    .table_modle{
      width: 100%;
    }
  }
</style>
